import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Text, Select, QuantityControls, useToasts } from '@lounge-fe/ui-kit'

import { useRemoveCartItems } from '@/features/cart/hooks/useRemoveCartItems'
import { useUpdateCart } from '@/features/cart/hooks/useUpdateCart'
import { BasketLineQuantityProps } from './types'
import { RestError } from '@lounge-fe/network'

const MAX_QUANTITY = 20

export const Quantity = ({
  isDesktop,
  quantity,
  isSet,
  lineItemKeys,
}: BasketLineQuantityProps) => {
  const { toast } = useToasts()
  const { t } = useTranslation()
  const removeItems = useRemoveCartItems()
  const update = useUpdateCart()
  const [isUpdating, setIsUpdating] = useState(false)

  const onQuantityUpdate = (value: number) => {
    setIsUpdating(true)
    update.mutate(
      {
        updates: Object.fromEntries(
          lineItemKeys.flatMap((key) =>
            Array.isArray(key)
              ? key.map((k, index) => (index === 0 ? [k, value] : [k, 0]))
              : [[key, value]],
          ),
        ),
      },
      {
        onSettled: () => {
          setIsUpdating(false)
        },
        onError: (error) => {
          if (error instanceof RestError) {
            toast({
              severity: 'critical',
              title: t('general.error'),
              message: error.data.description ?? t('general.error_unexpected'),
              direction: isDesktop ? 'left' : 'top',
            })
          }
        },
      },
    )
  }

  return (
    <QuantityControls
      value={quantity}
      renderValue={(value) => <Text variant="body-md">{value}</Text>}
      onChange={onQuantityUpdate}
      isLoading={update.isPending}
      disabled={removeItems.isPending || isUpdating}
      max={MAX_QUANTITY}
    />
  )
}
